export enum UpdateInstallAction {
	DownloadAndInstall = 'DownloadAndInstall',
	DownloadOnly = 'DownloadOnly',
	InstallOnly = 'InstallOnly'
}
